var map = {
	"./module-1/module-bg.jpg": "4151",
	"./module-2/module-bg.jpg": "5ed5",
	"./module-3/module-bg.jpg": "2992",
	"./module-4/module-bg.jpg": "b0e8",
	"./module-5/module-bg.jpg": "a478",
	"./module-6/module-bg.jpg": "07e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9619";